const Progress = ({ id, totalQuestionNum }) => {
  return (
    <div
      className="bg-[#222] md:h-[26px] h-[18px] md:p-2 p-[0.4rem] rounded-3xl relative left-[50%] translate-x-[-50%] overflow-hidden"
      style={{ width: `${totalQuestionNum * 8}%` }}
    >
      <span
        className="_progress h-full block"
        style={{
          width: `${id * 10}%`,
          transition: 'width 400ms ease-in',
        }}
      ></span>
    </div>
  )
}

export default Progress
